import { analytics } from 'libs';
import Filter from './Filter';
import Toggle from './Toggle';

interface TermTypeOption {
  key?: string;
  value?: string;
  filter: { type: string | null };
}

const options: TermTypeOption[] = [
  { key: 'Fixed', value: 'Fixed', filter: { type: 'Fixed' } },
  { key: 'Variable', value: 'Variable', filter: { type: 'Variable' } },
  { key: 'HELOC', value: 'HELOC', filter: { type: 'HELOC' } },
];

interface TermTypeFilterProps {
  filters: { type?: string };
  onFilter: (update: { type: string | null }) => void;
}

const TermTypeFilter = ({ filters, onFilter }: TermTypeFilterProps) => {
  const onChange = (value: string) => {
    let selected = options.find((option) => option.key === value)!;

    if (selected.key === filters.type) {
      selected = { filter: { type: null } };
    }

    analytics.productSearch.filter({
      term_type: selected.filter.type || 'cleared',
    });

    onFilter(selected.filter);
  };

  return (
    <Filter name="Term Type">
      <Toggle onChange={onChange} options={options as any} testId="filter-term-type" value={filters.type || false} />
    </Filter>
  );
};

export default TermTypeFilter;
